import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InitialLoaderService {
  isShown = false;

  constructor() {
    (window as any).overlay = this;
  }

  show(): void {
    this.isShown = true;
  }

  hide(): void {
    this.isShown = false;
  }
}
